module.exports = __webpack_public_path__ + "components/country-flag/static/pw-62d1f5b889e0c6b8d8e981ca81d98090.svg";